import EventDetailLayout from '@/layouts/EventDetail';

export const unstable_settings = {
  initialRouteName: 'index',
};

export default function PrivateTabsOrganizationEventEventIdLayoutRoute() {
  return <EventDetailLayout basePath="/organization/event" />;
}
